<template>
  <div>
    <div v-if="!jqtip">
      <!-- <div class="update-des-p" v-if="!isMobile"></div>
      <div class="update-des-m" v-else></div>-->
    </div>
    <div class="footer" v-if="!isMobile">
      <div class="wrap">
        <div @click="gotoOther(0)">关于益盟</div>
        <div @click="gotoOther(3)">公司资质</div>
        <div @click="gotoOther(6)">营销人员职责范围</div>
        <div>服务热线</div>
      </div>
      <div class="wrap small">
        <div @click="gotoOther(1)">PC产品中心</div>
        <div @click="gotoOther(4)">商务合作</div>
        <div @click="gotoOther(7)">联系我们</div>
        <div>益盟操盘手电脑版 &nbsp;客服热线:10108688</div>
      </div>
      <div class="wrap small">
        <div @click="gotoOther(2)">客户咨询</div>
        <div @click="gotoOther(5)">投资者关系</div>
        <div @click="gotoOther(8)">风险提示</div>
        <div>益盟操盘手手机版 &nbsp;客服热线:400-670-9090</div>
      </div>
      <div class="copy-message">
        <div class="copy">版权所有:益盟股份有限公司</div>
        <div class="records">沪ICP备06000340</div>
        <div class="tips">软件需数据支持,仅提供辅助建议,投资需谨慎;投资顾问意见仅供参考</div>
      </div>
    </div>
    <div class="mobile-footer" v-if="isMobile">
      <div class="wrap">
        <div @click="gotoOther(0)">关于益盟</div>
        <div @click="gotoOther(3)">公司资质</div>
        <div @click="gotoOther(6)">营销人员职责范围</div>
      </div>
      <div class="wrap small">
        <div @click="gotoOther(1)">PC产品中心</div>
        <div @click="gotoOther(4)">商务合作</div>
        <div @click="gotoOther(7)">联系我们</div>
      </div>
      <div class="wrap small">
        <div @click="gotoOther(2)">客户咨询</div>
        <div @click="gotoOther(5)">投资者关系</div>
        <div @click="gotoOther(8)">风险提示</div>
      </div>
      <div class="phone-wrap">
        <div class="left">服务热线:</div>
        <div class="right">
          <div>益盟操盘手电脑版 &nbsp;客服热线:10108688</div>
          <div>益盟操盘手手机版 &nbsp;客服热线:400-670-9090</div>
        </div>
      </div>
      <div class="copy-message">
        <div class="copy">版权所有:益盟股份有限公司</div>
        <div class="records">沪ICP备06000340</div>
        <div class="tips">软件需数据支持,仅提供辅助建议,投资需谨慎;投资顾问意见仅供参考</div>
      </div>
    </div>
  </div>
</template>

<script>
import appInfo from '@/assets/js/appInfo.js'

export default {
  data() {
    return {
      jqtip: appInfo.getParam('jqtip')
    }
  },
  props: ['isMobile'],
  methods: {
    gotoOther(index) {
      switch (index) {
        case 0:
          window.location.href = 'http://www.emoney.cn/index/page1.html'
          break
        case 1:
          window.location.href = 'http://product.emoney.cn/'
          break
        case 2:
          window.location.href =
            'http://wpa.b.qq.com/cgi/wpa.php?ln=2&uin=4006706888'
          break
        case 3:
          window.location.href = 'http://www.emoney.cn/index/page2.html#nogo'
          break
        case 4:
          window.location.href = 'http://www.emoney.cn/index/contact.html'
          break
        case 5:
          window.location.href = 'http://www.emoney.cn/index/Investor/GSGG'
          break
        case 6:
          window.location.href = 'http://www.emoney.cn/index/page2.html#nogo'
          break
        case 7:
          window.location.href = 'http://www.emoney.cn/index/contact.html'
          break
        case 8:
          window.location.href =
            'http://www.emoney.cn/dianjin/abby/2013_1_kq/index.html'
          break
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.update-des-p {
  position: relative;
  padding-bottom: 310/1920 * 100%;
  background: url('./images/earn4.png') no-repeat;
  background-size: cover;
}
.update-des-m {
  position: relative;
  padding-bottom: 310/750 * 100%;
  background: url('./images/mearn4.png') no-repeat;
  background-size: cover;
}
.mobile-footer {
  overflow: hidden;
  height: 420px;
  background-color: #333;
  color: #999;
  // display: flex;
  // flex-direction: column;
  // align-items: center;
  padding: 0 30px 0 42px;
  .copy-message {
    font-size: 18px;
    margin-top: 40px;
    > div {
      margin-top: 10px;
    }
  }
  .wrap {
    margin: 20px auto 0;
    display: flex;
    font-size: 22px;
    > div {
      width: 232px;
      text-align: left;
      white-space: nowrap;
      &:last-child {
        width: 210px;
        white-space: nowrap;
        // margin-left: 60px;
      }
    }
  }
  .small {
    font-size: 18px;
  }
  .phone-wrap {
    display: flex;
    font-size: 22px;
    align-items: center;
    margin: 40px auto 0;
    text-align: left;
    .right > div {
      font-size: 18px;
      margin: 10px 0 0 40px;
    }
  }
}
.footer {
  overflow: hidden;
  height: 370px;
  background-color: #333;
  color: #999;
  display: flex;
  flex-direction: column;
  align-items: center;
  .copy-message {
    font-size: 18px;
    margin-top: 90px;
    > div {
      margin-top: 10px;
    }
  }
  .wrap {
    margin: 30px auto 0;
    display: flex;
    font-size: 22px;
    cursor: pointer;
    > div {
      width: 180px;
      text-align: left;
      white-space: nowrap;
      &:last-child {
        width: 360px;
        white-space: nowrap;
        margin-left: 60px;
      }
    }
  }
  .small {
    font-size: 18px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer/Footer.vue